var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioWavesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_202_21",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_202_21",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAHISURBVEiJ7ZW7alRRFIa/NU4yCsJYCCqoJCKIiqBdkOATiI2kEEHtRfElfASJhYhBsQmInYiFtaWgFmLAYRCSIt6Cl5jJfBZZA2cOY2Ymjp1/s/a6/Ovf7L3POtAH6jW1oa6ot9RaP87AUM+5gZ/q51zfHKXAbDY9r+5R2+qrYXpU+uR3pl2KiCVgHaiPUuCvUQVQzwAzwCIwGxEfByGr24CzwGngBfA4Itrlokt5th001N2Zu5+x6fTX1GaBe8duPOi1i4UkXlbns/BGPwF1f+YW1Bn1XfoHi/0rwCTwISLmgLmMHxrghI6nfRYR88DT9E/kBqrqeBUIwBI5BhDo1HS47VL8CTBRHaDRVnEYmPjnz/S/QF9UgZdAYwvcJtAC3m8qEBEnC/5a2s7MH0/bKhMj4rW6NyKWM/Qr7Vja7cBqF0ndp66qX9V76g/1m7or812josS9kF/yW/VRrp/3Kryqtgo/miuFXHkW1QrrivqwMJcW1VO9NoN6QJ3qDL1eAuoR9bt6vVRzTJ1WxyDHdRkR0WTjEjfDJLADOFrivin6wz7TFaCu1oHO1Pw0ZI8/Q72b5/sl72ldnRqlQE29rS7na7nYj/Mb0fCozOz6wfwAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioWavesIcon);
export default __webpack_public_path__ + "static/media/audio_waves_icon.d136eb0d4d6c28200451cbe3d1c651cb.svg";
export { ForwardRef as ReactComponent };